import { MoreVertRounded, SvgIconComponent } from '@mui/icons-material';
import {
    Box,
    Button,
    ButtonProps,
    IconButton,
    ListItemIcon,
    Menu,
    MenuItem,
    MenuItemProps,
    Stack,
} from '@mui/material';
import { useState } from 'react';

type MenuItemButtonProps = MenuItemProps & ButtonProps;

interface QuickOptionBase extends MenuItemButtonProps {
    Icon?: SvgIconComponent;
    quickButton?: boolean;
}

interface QuickOptionWithLabel extends QuickOptionBase {
    label: string;
    element?: never;
}

interface QuickOptionWithElement extends QuickOptionBase {
    element: React.ReactNode;
    label?: never;
}

export type QuickOption = QuickOptionWithLabel | QuickOptionWithElement;

interface QuickOptionsProps {
    options?: QuickOption[];
    size?: 'small' | 'medium' | 'large';
    children?: React.ReactNode;
}

const QuickOptions: React.FC<QuickOptionsProps> = ({
    options,
    size = 'medium',
    children,
}) => {
    const [anchorEL, setAnchorEl] = useState(null);
    const quickButtonOptions = options.filter(option => option.quickButton);
    const regularOptions = options.filter(option => !option.quickButton);

    return (
        <Box>
            <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                width="max-content"
            >
                {quickButtonOptions.map(
                    ({ element, label, Icon, quickButton, ...rest }) => {
                        if (element) return element;
                        return (
                            <Button
                                variant="outlined"
                                size={size}
                                key={label}
                                startIcon={Icon && <Icon />}
                                {...rest}
                            >
                                {label}
                            </Button>
                        );
                    },
                )}
                {children ? (
                    <Box onClick={e => setAnchorEl(e.currentTarget)}>
                        {children}
                    </Box>
                ) : (
                    <IconButton
                        size={size}
                        onClick={e => setAnchorEl(e.currentTarget)}
                    >
                        <MoreVertRounded />
                    </IconButton>
                )}
                <Menu
                    anchorEl={anchorEL}
                    open={Boolean(anchorEL)}
                    onClose={() => setAnchorEl(null)}
                    // anchorOrigin={{
                    //     vertical: 'top',
                    //     horizontal: 'right',
                    // }}
                    // transformOrigin={{
                    //     vertical: 'bottom',
                    //     horizontal: 'right',
                    // }}
                >
                    {regularOptions.map(({ label, Icon, ...rest }) => (
                        <MenuItem key={label} {...rest}>
                            {Icon && (
                                <ListItemIcon>
                                    <Icon fontSize="small" />
                                </ListItemIcon>
                            )}
                            {label}
                        </MenuItem>
                    ))}
                </Menu>
            </Stack>
        </Box>
    );
};

export default QuickOptions;
